import { BeakerIcon } from "@heroicons/react/24/outline"

export default function BetaIcon() {
  return (
    <div className="flex items-center bg-brand rounded-system-xs p-system-xxs">
      <BeakerIcon className="w-system-md h-system-md" />
    </div>
  )
}
